/* Creative Wall — プレミアム立体・浮かし額装 LP スクリプト
   Uploaded to Shopify → Assets folder as: cw-floating-frame.js
   Referenced in each section via: <script src="{{ 'cw-floating-frame.js' | asset_url }}" defer></script>
*/
(function(){
  if (window.__cwLpInit) return;
  window.__cwLpInit = true;

  function init() {
    // Reveal on scroll
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    function observe(){
      document.querySelectorAll('.cw-lp .reveal:not(.in)').forEach(function(el){ io.observe(el); });
    }
    observe();
    new MutationObserver(observe).observe(document.body, { childList: true, subtree: true });

    // Color swatch → photo swap
    var COLOR_MAP = {
      white:   { name: 'ホワイト',       code: 'WHT-01', desc: '清潔感と抜け感。北欧テイストや白基調のモダンなお部屋に。' },
      natural: { name: 'ナチュラル',     code: 'NAT-02', desc: '木のぬくもりが最も引き立つ、万能な定番カラー。' },
      oak:     { name: 'オーク',         code: 'OAK-03', desc: '深みのあるブラウン。落ち着いたリビングや書斎に重厚感を。' },
      black:   { name: 'ブラック',       code: 'BLK-04', desc: 'ギャラリー・ミュージアム仕様。作品の色彩を最大限際立たせる。' },
      pink:    { name: 'パステルピンク', code: 'PNK-05', desc: 'やわらかく愛らしい印象。子供部屋やドレッサー周りに。' }
    };
    document.addEventListener('click', function(ev){
      var btn = ev.target.closest('.cw-lp [data-color-swatch]');
      if (!btn) return;
      var c = btn.dataset.colorSwatch;
      var info = COLOR_MAP[c]; if (!info) return;
      document.querySelectorAll('.cw-lp [data-color-swatch]').forEach(function(s){ s.classList.toggle('active', s.dataset.colorSwatch === c); });
      document.querySelectorAll('.cw-lp [data-color-photo-viewer] img').forEach(function(img){ img.classList.toggle('active', img.dataset.colorPhoto === c); });
      document.querySelectorAll('.cw-lp [data-color-name]').forEach(function(el){ el.textContent = info.name; });
      document.querySelectorAll('.cw-lp [data-color-code]').forEach(function(el){ el.textContent = info.code; });
      document.querySelectorAll('.cw-lp [data-color-desc]').forEach(function(el){ el.textContent = info.desc; });
    });

    // Scene tabs
    document.addEventListener('click', function(ev){
      var tab = ev.target.closest('.cw-lp [data-scene-tab]');
      if (!tab) return;
      var group = tab.closest('[data-scene-group]');
      if (!group) return;
      var k = tab.dataset.sceneTab;
      group.querySelectorAll('[data-scene-tab]').forEach(function(x){ x.classList.toggle('active', x === tab); });
      group.querySelectorAll('[data-scene-panel]').forEach(function(p){ p.style.display = (p.dataset.scenePanel === k) ? '' : 'none'; });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();